import type { VideoReference } from '@/api/types';

/**
 * Выбор в трей живёт отдельно от выдачи: видео хранятся объектами, поэтому новый
 * поиск или фильтр не прячет выбранное и трей показывает ровно то, что уйдёт в Save
 * и на канвас. Повторный клик снимает выбор; id не из выдачи выбор не меняет.
 */
export function toggleTraySelection(
  selection: readonly VideoReference[],
  id: number,
  visible: readonly VideoReference[],
): VideoReference[] {
  if (selection.some((v) => v.id === id)) return selection.filter((v) => v.id !== id);
  const video = visible.find((v) => v.id === id);
  return video ? [...selection, video] : [...selection];
}

/** Выбранные видео в свежей версии, если они есть в текущей выдаче (закладки, канвасы). */
export function freshTrayVideos(
  selection: readonly VideoReference[],
  visible: readonly VideoReference[],
): VideoReference[] {
  const byId = new Map(visible.map((v) => [v.id, v]));
  return selection.map((v) => byId.get(v.id) ?? v);
}
